export default __webpack_public_path__ + "static/construction-blue-bg-46b96c7bdc32e3d73b9d880d9d8435d4.jpg";